import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from './Button';
import Input from './Input';
import BuildBaseIcon from '../Icons/BuildBaseIcon';
import { getFooterContent } from '../api-sanity/api';
import useMediaQuery from 'hooks/useMediaQuery';

const Footer = ({ isDarkMode = false }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [footerData, setFooterData] = useState(null);
  const isMobileSize = useMediaQuery();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchFooterData = async () => {
      const data = await getFooterContent();
      if (!data.error) {
        setFooterData(data);
      }
    };
    fetchFooterData();
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (emailError) {
      setEmailError(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim() || !validateEmail(email)) {
      setEmailError(true);
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append(
      'Authorization',
      'Bearer skNeRLxHT0sGe9HaThzwVRYv8MMzFqQq9GlV9GhYD7LKKqLtMFJpT1AgZ0bYAa460uMMIjLs8cqnBjOMUxamTflqRDuBbjU4eisDp8TWTr1zpsOS5JjxupZns4h6xHZ3kvXiYqnDacG0ymlMm19SlIWH9AlGIXM7MUdOHY167ln0Pz4XAPrw'
    );

    const raw = JSON.stringify({
      mutations: [
        {
          create: {
            email,
            _id: Math.floor(Date.now() / 1000).toString(),
            _type: 'newsletter',
            createdAt: new Date().toISOString(),
          },
        },
      ],
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(
      'https://kxxtoumf.api.sanity.io/v2025-05-12/data/mutate/production',
      requestOptions
    )
      .then((response) => response.text())
      .then(() => {
        setEmail('');
        setEmailError(false);
      })
      .catch((error) => console.error(error));
  };

  const handleLinkClick = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const renderNewsletterText = () => {
    if (!footerData?.newsletterText || !footerData?.newsletterButtonText) {
      return null;
    }

    const text = footerData.newsletterText;
    const buttonText = footerData.newsletterButtonText;
    const buttonUrl = footerData.newsletterButtonUrl;

    const parts = text.split(buttonText);
    if (parts.length !== 2) {
      return <p>{text}</p>;
    }

    return (
      <p className='footer-newsletter-text'>
        {parts[0]}
        <span
          className='underline cursor-pointer'
          onClick={() => handleLinkClick(buttonUrl)}
        >
          {' '}
          {buttonText}
        </span>
        {parts[1]}
      </p>
    );
  };

  return (
    <div className={`footer-container ${isDarkMode ? 'dark' : ''}`}>
      <div className='flex footer-links-wrapper '>
        <div className='on-mobile-hidden'>
          <BuildBaseIcon
            width='90%'
            height='100%'
            maxwidth={390}
            onClick={() => navigate('/')}
            className='cursor-pointer'
          />
        </div>
        <div className='flex footer-links'>
          {!isMobileSize && (
            <div>
              <span className='ft-tile'>HOME</span>
              <span
                className='ft-btn'
                onClick={() => handleLinkClick(footerData?.projectUrl)}
              >
                PROJECT
              </span>
              <span
                className='ft-btn'
                onClick={() => handleLinkClick(footerData?.aboutUrl)}
              >
                ABOUT
              </span>
              <span className='ft-btn' onClick={() => navigate('/contact')}>
                CONTACTS
              </span>
            </div>
          )}

          <div>
            <span className='ft-tile'>SOCIALS</span>
            <span
              className='ft-btn'
              onClick={() => handleLinkClick(footerData?.instagramUrl)}
            >
              INSTAGRAM
            </span>
            <span
              className='ft-btn'
              onClick={() => handleLinkClick(footerData?.linkedinUrl)}
            >
              LINKEDIN
            </span>
            <span
              className='ft-btn'
              onClick={() => handleLinkClick(footerData?.twitterUrl)}
            >
              TWITTER
            </span>
          </div>
          <div>
            <span className='ft-tile'>INFO</span>
            <span>SWITZERZAND</span>
            <span>BASEL</span>
            <span>INFO@BUILD:BASE.CH</span>
          </div>
        </div>
      </div>
      <div className='flex footer-newsletter-wrapper'>
        <div className='footer-newsletter'>
          {!(isMobileSize && location.pathname === '/contact') && (
            <>
              <span className='ft-tile'>NEWSLETTER</span>
              {renderNewsletterText()}
              <Input
                onChange={handleEmailChange}
                value={email}
                type='email'
                name='email'
                placeholder='Write your email'
                className={emailError ? 'validation-error' : ''}
              />
              <Button onClick={handleSubmit}>Send</Button>
            </>
          )}
          <div className='on-desktop-hidden logo-wrapper'>
            <BuildBaseIcon
              width='100%'
              height='100%'
              onClick={() => navigate('/')}
              className='cursor-pointer'
            />
          </div>
        </div>
        <span className='footer-copyright'>
          © 2025 Build:base. All rights reserved.
        </span>
      </div>
    </div>
  );
};

export default Footer;
